import { Form } from '@ant-design/compatible';
import cx from 'classnames';
import RadioGroup from '../../input/RadioGroup/RadioGroup';
import React from 'react';
import TextAreaForm from '../TextAreaForm';

const RadioGroupWithInputForm = (props) => {
  const {
    className,
    form,
    label,
    rules,
    name,
    list,
    initialValue,
    maxLength,
    onChange,
    disabled,
    direction,
    isEditable,
  } = props;

  const { getFieldDecorator } = form;

  return (
    <Form.Item className={cx('form-radio-group', 'amondz-form', className)} label={label}>
      {isEditable &&
        getFieldDecorator(name, {
          initialValue: list.length - 1,
        })(<RadioGroup list={list} size="large" disabled={disabled} direction={direction} />)}
      {(form.getFieldValue(name) === list.length - 1 || !isEditable) && (
        <TextAreaForm
          form={form}
          rules={rules}
          maxLength={maxLength}
          isEditable={isEditable}
          initialValue={initialValue}
          onChange={onChange}
          name={name + 'manual'}
        />
      )}
    </Form.Item>
  );
};

export default RadioGroupWithInputForm;
